"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _spauiFormgroup = _interopRequireDefault(require("@tencent/spaui-formgroup"));

var _spauiInput = _interopRequireDefault(require("@tencent/spaui-input"));

var _info = _interopRequireDefault(require("./info"));

var _timepicker_props = require("./timepicker_props");

var _index = require("./utils/index");

var _timepicker_compact_props = _interopRequireDefault(require("./timepicker_compact_props"));

var _odAnimate = _interopRequireDefault(require("@tencent/od-animate"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var TimePicker =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(TimePicker, _PureComponent);

  function TimePicker(props) {
    var _this;

    _classCallCheck(this, TimePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimePicker).call(this, props));
    _this._insideClick = false;

    var _campactProps = (0, _timepicker_compact_props["default"])(props),
        _campactProps$open = _campactProps.open,
        open = _campactProps$open === void 0 ? false : _campactProps$open;

    _this.state = {
      open: open
    };

    _this.nullList();

    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    _this.handleClickItem = _this.handleClickItem.bind(_assertThisInitialized(_this));
    _this.handleOpen = _this.handleOpen.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleBlur = _this.handleBlur.bind(_assertThisInitialized(_this));
    _this.documentClick = _this.documentClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(TimePicker, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTimeAtTop();
      this.listenDocumentClick();

      if ((0, _spauiUtils.isFunction)(_spauiUtils.checkCssVersion)) {
        (0, _spauiUtils.checkCssVersion)(_info["default"]);
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps() {
      var _this2 = this;

      var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _campactProps2 = (0, _timepicker_compact_props["default"])(nextProps),
          open = _campactProps2.open;

      var _campactProps3 = (0, _timepicker_compact_props["default"])(this.props),
          propsOpen = _campactProps3.open;

      if (!(0, _spauiUtils.isUndefined)(open)) {
        this.setState({
          open: open
        }, function () {
          if (open && open !== propsOpen) {
            _this2.setTimeAtTop();
          }
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.listenDocumentClick();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeListenDocumentClick();
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.hourDom = null;
      this.minuteDom = null;
      this.secondDom = null;
    }
  }, {
    key: "listenDocumentClick",
    value: function listenDocumentClick() {
      var open = this.state.open; // 需要回收

      if (open && !this.haveDocumentClick) {
        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.addEventListener)) {
          document.addEventListener('click', this.documentClick);
        }

        this.haveDocumentClick = true;
      } else if (!open) {
        this.removeListenDocumentClick();
      }
    } // 回收下页面点击监听

  }, {
    key: "removeListenDocumentClick",
    value: function removeListenDocumentClick() {
      if (this.haveDocumentClick) {
        if ((typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && (0, _spauiUtils.isFunction)(document.removeEventListener)) {
          document.removeEventListener('click', this.documentClick);
        }

        this.haveDocumentClick = false;
        this._insideClick = false;
      }
    } // 点击document的点击事件

  }, {
    key: "documentClick",
    value: function documentClick(event) {
      var open = this.state.open; // 不是点击的组件才响应

      if (event && event.target && open && !this._insideClick) {
        this.handleOpen(event, false);
      }

      this._insideClick = false;
    } // 第一次打开时，选中值默认在最上方

  }, {
    key: "setTimeAtTop",
    value: function setTimeAtTop() {
      (0, _index.setNodeAtTop)(this.hourDom);
      (0, _index.setNodeAtTop)(this.minuteDom);
      (0, _index.setNodeAtTop)(this.secondDom);
    } // 转化加0

  }, {
    key: "getTimeList",
    value: function getTimeList() {
      var _this$props = this.props,
          _this$props$hourList = _this$props.hourList,
          hourList = _this$props$hourList === void 0 ? [] : _this$props$hourList,
          _this$props$minuteLis = _this$props.minuteList,
          minuteList = _this$props$minuteLis === void 0 ? [] : _this$props$minuteLis,
          _this$props$secondLis = _this$props.secondList,
          secondList = _this$props$secondLis === void 0 ? [] : _this$props$secondLis;
      return {
        hourList: hourList.map(_index.addZero),
        minuteList: minuteList.map(_index.addZero),
        secondList: secondList.map(_index.addZero)
      };
    } // 获取时间字符串

  }, {
    key: "getTimeString",
    value: function getTimeString() {
      var hour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var second = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var needAddZero = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      var _getComponentType = (0, _index.getComponentType)(this.props),
          onlyHour = _getComponentType.onlyHour,
          onlyHourAndMinute = _getComponentType.onlyHourAndMinute,
          hourAndMinuteAndSecond = _getComponentType.hourAndMinuteAndSecond;

      var _this$getTimeList = this.getTimeList(),
          _this$getTimeList$min = _this$getTimeList.minuteList,
          minuteList = _this$getTimeList$min === void 0 ? [] : _this$getTimeList$min,
          _this$getTimeList$sec = _this$getTimeList.secondList,
          secondList = _this$getTimeList$sec === void 0 ? [] : _this$getTimeList$sec;

      var _hour = hour;
      var _minute = minute;
      var _second = second;
      var result = [];

      if (needAddZero) {
        _hour = (0, _index.addZero)(_hour);
        _minute = (0, _index.addZero)(_minute);
        _second = (0, _index.addZero)(_second);
      }

      if (onlyHour) {
        if (_hour) {
          result = [_hour, '00'];
        }
      } else if (onlyHourAndMinute) {
        if (_hour && _minute) {
          result = [_hour, _minute];
        } else if (_hour) {
          result = [_hour, minuteList[0] || '00'];
        }
      } else if (hourAndMinuteAndSecond) {
        if (_hour && _minute && _second) {
          result = [_hour, _minute, _second];
        } else if (_hour && _minute) {
          result = [_hour, _minute, secondList[0] || '00'];
        } else if (_hour) {
          result = [_hour, minuteList[0] || '00', secondList[0] || '00'];
        }
      }

      return result.join(':');
    } // 是否对应的选项需要禁用

  }, {
    key: "isDisabled",
    value: function isDisabled(hour, minute, second) {
      var _this$props2 = this.props,
          _this$props2$beginTim = _this$props2.beginTime,
          beginTime = _this$props2$beginTim === void 0 ? '' : _this$props2$beginTim,
          _this$props2$endTime = _this$props2.endTime,
          endTime = _this$props2$endTime === void 0 ? '' : _this$props2$endTime;
      var beginTimeArr = beginTime ? beginTime.split(':') : [];
      var endTimeArr = endTime ? endTime.split(':') : [];
      var theDate = '2018-10-10 '; // 假设一个日期，实际值没啥意义，主要是用来跟时分秒凑成一个日期

      var _getComponentType2 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType2.onlyCustomTime;

      var result = false;
      var itemTimeStamp = 0;
      var beginTimeStamp = 0;
      var endTimeStamp = 0;

      if ((beginTimeArr.length > 0 || endTimeArr.length > 0) && (typeof hour !== 'undefined' || typeof minute !== 'undefined' || typeof second !== 'undefined')) {
        if (onlyCustomTime) {
          itemTimeStamp = new Date(theDate + (hour.indexOf(':') > -1 ? hour : [hour, '00'].join(':'))).getTime();

          if (beginTimeArr.length > 0) {
            beginTimeStamp = new Date(theDate + beginTime).getTime();
          }

          if (endTimeArr.length > 0) {
            endTimeStamp = new Date(theDate + endTime).getTime();
          } // 针对只有小时的

        } else if (typeof hour !== 'undefined' && typeof minute === 'undefined' && typeof second === 'undefined') {
          itemTimeStamp = new Date(theDate + [hour, '00'].join(':')).getTime();

          if (beginTimeArr.length > 0) {
            beginTimeStamp = new Date(theDate + [beginTimeArr[0] || '00', '00'].join(':')).getTime();
          }

          if (endTimeArr.length > 0) {
            endTimeStamp = new Date(theDate + [endTimeArr[0] || '00', '00'].join(':')).getTime();
          } // 针对时分

        } else if (typeof hour !== 'undefined' && typeof minute !== 'undefined' && typeof second === 'undefined') {
          itemTimeStamp = new Date(theDate + [hour, minute].join(':')).getTime();

          if (beginTimeArr.length > 0) {
            beginTimeStamp = new Date(theDate + [beginTimeArr[0] || '00', beginTimeArr[1] || '00'].join(':')).getTime();
          }

          if (endTimeArr.length > 0) {
            endTimeStamp = new Date(theDate + [endTimeArr[0] || '00', endTimeArr[1] || '00'].join(':')).getTime();
          } // 针对时分秒

        } else if (typeof hour !== 'undefined' && typeof minute !== 'undefined' && typeof second !== 'undefined') {
          itemTimeStamp = new Date(theDate + [hour, minute, second].join(':')).getTime();

          if (beginTimeArr.length > 0) {
            beginTimeStamp = new Date(theDate + [beginTimeArr[0] || '00', beginTimeArr[1] || '00', beginTimeArr[2] || '00'].join(':')).getTime();
          }

          if (endTimeArr.length > 0) {
            endTimeStamp = new Date(theDate + [endTimeArr[0] || '00', endTimeArr[1] || '00', endTimeArr[2] || '00'].join(':')).getTime();
          }
        } // 如果有当前时间戳，以及开始结束时间戳就对比下


        if (itemTimeStamp) {
          if (beginTimeStamp) {
            if (beginTimeStamp > itemTimeStamp) {
              result = true;
            }
          }

          if (endTimeStamp) {
            if (endTimeStamp < itemTimeStamp) {
              result = true;
            }
          }
        }
      }

      return result;
    } // 根据时间字符串拆分出对应的时间数据

  }, {
    key: "getDataByTimeString",
    value: function getDataByTimeString() {
      var nextValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var _this$props3 = this.props,
          _this$props3$value = _this$props3.value,
          value = _this$props3$value === void 0 ? '' : _this$props3$value,
          _this$props3$timeList = _this$props3.timeList,
          timeList = _this$props3$timeList === void 0 ? [] : _this$props3$timeList;

      var _getComponentType3 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType3.onlyCustomTime;

      var _this$getTimeList2 = this.getTimeList(),
          _this$getTimeList2$ho = _this$getTimeList2.hourList,
          hourList = _this$getTimeList2$ho === void 0 ? [] : _this$getTimeList2$ho,
          _this$getTimeList2$mi = _this$getTimeList2.minuteList,
          minuteList = _this$getTimeList2$mi === void 0 ? [] : _this$getTimeList2$mi,
          _this$getTimeList2$se = _this$getTimeList2.secondList,
          secondList = _this$getTimeList2$se === void 0 ? [] : _this$getTimeList2$se;

      var finalValue = nextValue || value || '';
      var valueArr = finalValue.split(':') || [];
      var hour = '';
      var minute = '';
      var second = '';
      var time = '';

      if (onlyCustomTime) {
        timeList.map(function (item) {
          if (item.indexOf(finalValue) === 0) {
            time = finalValue;
          }

          return item;
        });
      } else {
        if (hourList.indexOf((0, _index.addZero)(valueArr[0])) > -1) {
          hour = valueArr[0];
        }

        if (minuteList.indexOf((0, _index.addZero)(valueArr[1])) > -1) {
          minute = valueArr[1];
        }

        if (secondList.indexOf((0, _index.addZero)(valueArr[2])) > -1) {
          second = valueArr[2];
        }

        if (!hour && finalValue) {
          hourList.map(function (item) {
            if (item && item.indexOf(finalValue) === 0) {
              hour = item;
            }

            return item;
          });
        }

        if (!minute && valueArr[1]) {
          minuteList.map(function (item) {
            if (item && item.indexOf(valueArr[1]) === 0) {
              minute = item;
            }

            return item;
          });
        }

        if (!second && valueArr[2]) {
          secondList.map(function (item) {
            if (item && item.indexOf(valueArr[2]) === 0) {
              second = item;
            }

            return item;
          });
        }

        time = this.getTimeString(hour, minute, second);
      }

      return {
        hour: hour,
        minute: minute,
        second: second,
        time: time
      };
    } // 展开回调

  }, {
    key: "handleOpen",
    value: function handleOpen(event, open) {
      var _this3 = this;

      var disabled = this.props.disabled;

      var _campactProps4 = (0, _timepicker_compact_props["default"])(this.props),
          onOpen = _campactProps4.onOpen,
          propsOpen = _campactProps4.open; // 禁用


      if (disabled) {
        return false;
      }

      if ((0, _spauiUtils.isUndefined)(propsOpen)) {
        this.setState({
          open: open
        }, function () {
          if (open && open !== propsOpen) {
            _this3.setTimeAtTop();
          }
        });
      }

      if ((0, _spauiUtils.isFunction)(onOpen)) {
        onOpen(event, open);
      }
    } // 点击

  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      var open = this.state.open;
      this.handleOpen(event, !open);

      if ((0, _spauiUtils.isFunction)(onClick)) {
        onClick(event);
      }
    } // 获取点击的值

  }, {
    key: "getClickItemValue",
    value: function getClickItemValue(type, value) {
      var _this4 = this;

      var _this$getDataByTimeSt = this.getDataByTimeString(),
          hour = _this$getDataByTimeSt.hour,
          minute = _this$getDataByTimeSt.minute,
          second = _this$getDataByTimeSt.second;

      var _getComponentType4 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType4.onlyCustomTime,
          onlyHour = _getComponentType4.onlyHour,
          onlyHourAndMinute = _getComponentType4.onlyHourAndMinute,
          hourAndMinuteAndSecond = _getComponentType4.hourAndMinuteAndSecond;

      var _this$getTimeList3 = this.getTimeList(),
          _this$getTimeList3$ho = _this$getTimeList3.hourList,
          hourList = _this$getTimeList3$ho === void 0 ? [] : _this$getTimeList3$ho,
          _this$getTimeList3$mi = _this$getTimeList3.minuteList,
          minuteList = _this$getTimeList3$mi === void 0 ? [] : _this$getTimeList3$mi,
          _this$getTimeList3$se = _this$getTimeList3.secondList,
          secondList = _this$getTimeList3$se === void 0 ? [] : _this$getTimeList3$se;

      var result = [];
      var unDisabledList = [];
      var unDisabledList2 = [];

      if (onlyCustomTime) {
        result = [value];
      } else if (onlyHour) {
        result = [value, '00'];
      } else if (onlyHourAndMinute) {
        if (type === 'hour') {
          // 获取下可以选择的列表
          unDisabledList = [];
          minuteList.map(function (item) {
            if (!_this4.isDisabled(value, item)) {
              unDisabledList.push(item);
            }

            return item;
          });
          result = [value, (0, _index.getDefaultValue)(minute, unDisabledList)];
        } else if (type === 'minute') {
          // 获取下可以选择的列表
          unDisabledList = [];
          hourList.map(function (item) {
            if (!_this4.isDisabled(item, value)) {
              unDisabledList.push(item);
            }

            return item;
          });
          result = [hour || unDisabledList[0] || '00', value];
        }
      } else if (hourAndMinuteAndSecond) {
        if (type === 'hour') {
          // 获取下可以选择的列表（需要带上second）
          unDisabledList = [];
          minuteList.map(function (item) {
            if (!_this4.isDisabled(value, item, second)) {
              unDisabledList.push(item);
            }

            return item;
          }); // 获取下可以选择的列表

          unDisabledList2 = [];
          secondList.map(function (item) {
            if (!_this4.isDisabled(value, (0, _index.getDefaultValue)(minute, unDisabledList), item)) {
              unDisabledList2.push(item);
            }

            return item;
          });
          result = [value, (0, _index.getDefaultValue)(minute, unDisabledList), (0, _index.getDefaultValue)(second, unDisabledList2)];
        } else if (type === 'minute') {
          // 获取下可以选择的列表
          unDisabledList = [];
          hourList.map(function (item) {
            if (!_this4.isDisabled(item, value, second)) {
              unDisabledList.push(item);
            }

            return item;
          }); // 获取下可以选择的列表

          unDisabledList2 = [];
          secondList.map(function (item) {
            if (!_this4.isDisabled((0, _index.getDefaultValue)(hour, unDisabledList), value, item)) {
              unDisabledList2.push(item);
            }

            return item;
          });
          result = [(0, _index.getDefaultValue)(hour, unDisabledList), value, (0, _index.getDefaultValue)(second, unDisabledList2)];
        } else if (type === 'second') {
          // 获取下可以选择的列表
          unDisabledList = [];
          hourList.map(function (item) {
            if (!_this4.isDisabled(item, minute || minuteList[0] || '00', value)) {
              unDisabledList.push(item);
            }

            return item;
          }); // 获取下可以选择的列表

          unDisabledList2 = [];
          minuteList.map(function (item) {
            if (!_this4.isDisabled((0, _index.getDefaultValue)(hour, unDisabledList), item, value)) {
              unDisabledList2.push(item);
            }

            return item;
          });
          result = [(0, _index.getDefaultValue)(hour, unDisabledList), (0, _index.getDefaultValue)(minute, unDisabledList2), value];
        }
      }

      return result.join(':');
    }
  }, {
    key: "handleClickItem",
    value: function handleClickItem(event, type, value) {
      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          onClickItem = _this$props4.onClickItem;

      var _getComponentType5 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType5.onlyCustomTime,
          onlyHour = _getComponentType5.onlyHour; // 禁用


      if (disabled) {
        return false;
      }

      var result = this.getClickItemValue(type, value);

      if (typeof result !== 'undefined') {
        this.handleChange(event, result);
      } // 单个面板的话点击就关闭


      if (onlyCustomTime || onlyHour) {
        this.handleOpen(event, false);
      }

      if ((0, _spauiUtils.isFunction)(onClickItem)) {
        onClickItem(event, type, value);
      }
    } // 变更回调

  }, {
    key: "handleChange",
    value: function handleChange(event, value) {
      var nextValue = !(0, _spauiUtils.isUndefined)(value) ? value : event.target.value || '';
      var _this$props5 = this.props,
          onChange = _this$props5.onChange,
          propsValue = _this$props5.value;

      var _this$getDataByTimeSt2 = this.getDataByTimeString(nextValue),
          time = _this$getDataByTimeSt2.time;

      var result = propsValue;

      if (!nextValue || time && time.indexOf(nextValue) === 0) {
        result = nextValue;
      }

      if ((0, _spauiUtils.isFunction)(onChange)) {
        onChange(event, result);
      }
    } // 失去焦点判断下内容

  }, {
    key: "handleBlur",
    value: function handleBlur(event) {
      var value = event.target.value || '';

      var _this$getDataByTimeSt3 = this.getDataByTimeString(value),
          hour = _this$getDataByTimeSt3.hour,
          minute = _this$getDataByTimeSt3.minute,
          second = _this$getDataByTimeSt3.second,
          time = _this$getDataByTimeSt3.time;

      var _getComponentType6 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType6.onlyCustomTime;

      var _this$props$timeList = this.props.timeList,
          timeList = _this$props$timeList === void 0 ? [] : _this$props$timeList;
      var result = '';

      if (value) {
        if (!time) {
          result = '';
        } else {
          if (onlyCustomTime) {
            timeList.map(function (item) {
              if (!result && item.indexOf(value) === 0) {
                result = item;
              }

              return item;
            });
          } else {
            result = this.getTimeString(hour, minute, second, true);
          }
        }

        this.handleChange(event, result);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _campactProps5 = (0, _timepicker_compact_props["default"])(this.props),
          write = _campactProps5.write,
          value = _campactProps5.value,
          placeholder = _campactProps5.placeholder,
          disabled = _campactProps5.disabled,
          timeList = _campactProps5.timeList,
          showPlaceholder = _campactProps5.showPlaceholder,
          clear = _campactProps5.clear,
          onClear = _campactProps5.onClear,
          transitionName = _campactProps5.transitionName,
          _campactProps5$config = _campactProps5.config,
          config = _campactProps5$config === void 0 ? {} : _campactProps5$config,
          _campactProps5$formGr = _campactProps5.formGroupProps,
          formGroupProps = _campactProps5$formGr === void 0 ? {} : _campactProps5$formGr;

      var _this$getDataByTimeSt4 = this.getDataByTimeString(),
          hour = _this$getDataByTimeSt4.hour,
          minute = _this$getDataByTimeSt4.minute,
          second = _this$getDataByTimeSt4.second,
          time = _this$getDataByTimeSt4.time;

      var _getComponentType7 = (0, _index.getComponentType)(this.props),
          onlyCustomTime = _getComponentType7.onlyCustomTime,
          onlyHourAndMinute = _getComponentType7.onlyHourAndMinute,
          hourAndMinuteAndSecond = _getComponentType7.hourAndMinuteAndSecond;

      var _this$getTimeList4 = this.getTimeList(),
          _this$getTimeList4$ho = _this$getTimeList4.hourList,
          hourList = _this$getTimeList4$ho === void 0 ? [] : _this$getTimeList4$ho,
          _this$getTimeList4$mi = _this$getTimeList4.minuteList,
          minuteList = _this$getTimeList4$mi === void 0 ? [] : _this$getTimeList4$mi,
          _this$getTimeList4$se = _this$getTimeList4.secondList,
          secondList = _this$getTimeList4$se === void 0 ? [] : _this$getTimeList4$se;

      var open = this.state.open; // 设置小时的classname

      var setHourClassName = function setHourClassName(item) {
        var result = '';

        if (onlyCustomTime) {
          if (item === time) {
            result = 'on';
          }
        } else {
          if (item === hour) {
            result = 'on';
          }
        }

        return result;
      };

      var needClear = value && clear;
      return _react["default"].createElement("div", _extends({}, (0, _spauiUtils.globalProps)(this.props, {
        className: (0, _classnames["default"])('spaui-timepicker', {
          'spaui-timepicker-delete': needClear
        })
      }, TimePicker, this.props), {
        onClick: function onClick() {
          if (_this5.haveDocumentClick) {
            _this5._insideClick = true;
          }
        }
      }), _react["default"].createElement("div", {
        className: "timechoose"
      }, _react["default"].createElement(_spauiFormgroup["default"], _extends({
        className: "has-feedback",
        style: {
          display: showPlaceholder ? '' : 'none'
        }
      }, formGroupProps), write ? // 可以输入的是个Input
      _react["default"].createElement(_spauiInput["default"], {
        value: value,
        placeholder: placeholder,
        disabled: disabled,
        onClick: this.handleClick,
        onChange: this.handleChange,
        onBlur: this.handleBlur
      }) : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('spaui-input', 'spaui-timepicker-valueholder', {
          placeholder: !value
        }),
        disabled: disabled,
        onClick: this.handleClick
      }, value || placeholder || ''), _react["default"].createElement("span", {
        className: "spaui-input-feedback",
        onClick: needClear ? _spauiUtils.noop : this.handleClick
      }, _react["default"].createElement("i", {
        className: "svg svg-time"
      }), needClear ? _react["default"].createElement("div", {
        className: "spaui-input-clear",
        role: "button",
        onClick: onClear
      }, _react["default"].createElement("svg", {
        viewBox: "0 0 16 16",
        width: "16px",
        height: "16px"
      }, _react["default"].createElement("circle", {
        fill: "currentColor",
        fillRule: "evenodd",
        cx: "8",
        cy: "8",
        r: "8"
      }), _react["default"].createElement("path", {
        d: "M5.333 5.333l5.334 5.334M10.667 5.333l-5.334 5.334",
        stroke: "#FFF",
        strokeLinecap: "square"
      }))) : null)), _react["default"].createElement(_odAnimate["default"], {
        transitionName: transitionName,
        component: ""
      }, open ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])('timepicker-dropdown spaui-timepicker-dropdown', {
          'with-minute': onlyHourAndMinute,
          'with-second': hourAndMinuteAndSecond
        })
      }, _react["default"].createElement("div", {
        className: "timer"
      }, _react["default"].createElement("ul", {
        className: "timer-hour"
      }, (onlyCustomTime ? timeList : hourList).map(function (item) {
        var hourDisabled = _this5.isDisabled(item, minute, second);

        var onClickTime = function onClickTime(event) {
          if (!hourDisabled) {
            _this5.handleClickItem(event, onlyCustomTime ? 'time' : 'hour', item);
          }
        };

        var getLabel = function getLabel() {
          var result = item;

          if (config.hour && !config.minute && !config.second && result.indexOf(':') < 0) {
            result += ':00';
          }

          return result;
        };

        return _react["default"].createElement("li", {
          key: item,
          onClick: onClickTime,
          ref: function ref(el) {
            if (setHourClassName(item) === 'on') {
              _this5.hourDom = el;
            }
          }
        }, _react["default"].createElement("a", {
          className: (0, _classnames["default"])('spaui-cursor-pointer', setHourClassName(item), {
            disabled: hourDisabled
          })
        }, getLabel()));
      })), onlyHourAndMinute || hourAndMinuteAndSecond ? _react["default"].createElement("ul", {
        className: "timer-minute"
      }, minuteList.map(function (item) {
        var minuteDisabled = _this5.isDisabled(hour, item, second);

        var onClickTime = function onClickTime(event) {
          if (!minuteDisabled) {
            _this5.handleClickItem(event, 'minute', item);
          }
        };

        return _react["default"].createElement("li", {
          key: item,
          onClick: onClickTime,
          ref: function ref(el) {
            if (minute === item) {
              _this5.minuteDom = el;
            }
          }
        }, _react["default"].createElement("a", {
          className: (0, _classnames["default"])('spaui-cursor-pointer', {
            on: minute === item,
            disabled: minuteDisabled
          })
        }, item));
      })) : null, hourAndMinuteAndSecond ? _react["default"].createElement("ul", {
        className: "timer-second"
      }, secondList.map(function (item) {
        var secondDisabled = _this5.isDisabled(hour, minute, item);

        var onClickTime = function onClickTime(event) {
          if (!secondDisabled) {
            _this5.handleClickItem(event, 'second', item);
          }
        };

        return _react["default"].createElement("li", {
          onClick: onClickTime,
          key: item,
          ref: function ref(el) {
            if (second === item) {
              _this5.secondDom = el;
            }
          }
        }, _react["default"].createElement("a", {
          className: (0, _classnames["default"])('spaui-cursor-pointer', {
            on: second === item,
            disabled: secondDisabled
          })
        }, item));
      })) : null)) : null)));
    }
  }]);

  return TimePicker;
}(_react.PureComponent); // 组件标记


_defineProperty(TimePicker, "propTypes", _timepicker_props.propTypes);

_defineProperty(TimePicker, "defaultProps", _timepicker_props.defaultProps);

(0, _spauiUtils.setComponentMark)(TimePicker, _info["default"]); // 组件上报

(0, _spauiUtils.reportComponentUsage)(_objectSpread({
  scope: 'spaui'
}, _info["default"])); // 用于 focus 样式只在键盘索引时生效，而在鼠标操作时不生效

(0, _spauiUtils.initFocusManager)('spaui-focus-disabled');
var _default = TimePicker;
exports["default"] = _default;